import { queryOptions, useQuery } from '@tanstack/react-query';

import { AddonsAPIProvider } from '@cast/types-omni';

import { apiClient } from '@cast/infrastructure-api';

const OMNI_ADDONS_QUERY_KEY = 'omni-addons';

const getAddonsQueryKey = (params: { provider?: AddonsAPIProvider } = {}) => {
  if (params.provider) {
    return [OMNI_ADDONS_QUERY_KEY, params.provider] as const;
  }

  return [OMNI_ADDONS_QUERY_KEY] as const;
};

const getAddonsQueryOptions = ({
  provider,
  enabled,
}: {
  provider?: AddonsAPIProvider;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getAddonsQueryKey({ provider }),
    queryFn: async () => {
      const { data } = await apiClient.omni.listAddons({
        provider,
      });

      return data.items ?? [];
    },
    enabled,
  });

export const useListAddonsQuery = ({
  provider,
  enabled = true,
}: {
  provider?: AddonsAPIProvider;
  enabled?: boolean;
} = {}) => {
  const { data, isLoading, error, refetch } = useQuery(
    getAddonsQueryOptions({ provider, enabled })
  );

  return {
    addons: data ?? [],
    isLoading,
    error,
    refetch,
  };
};
